import { render, staticRenderFns } from "./singleMail.vue?vue&type=template&id=3a2f65ba"
import script from "./singleMail.vue?vue&type=script&lang=js"
export * from "./singleMail.vue?vue&type=script&lang=js"
import style0 from "./singleMail.vue?vue&type=style&index=0&id=3a2f65ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports